export const MULTI_STEP = {
	PROGRAM: "program",
	COURSE: "course",
};
